import { MobileBlockHeader } from '@/components/molecules/MobileBlockHeader/MobileBlockHeader'
import { Flex } from 'antd'
import Link from 'next/link'
import React from 'react'
import { AppRoutes } from '@/routes'
import styles from './MobileAnnouncments.module.scss'

export function MobileAnnouncments() {
  return (
    <div>
      <MobileBlockHeader title="Notifications" viewAllTitle={null} />
      <div className={styles.root}>
        <div className={styles.announcmentBlock}>
          <Link href={AppRoutes.KYC_V2_PAGE}>
            <Flex vertical gap={8}>
              <p className={styles.announcmentTitle}>Pass KYC</p>
              <p className={styles.announcmentDescription}>Go through identification and get your first card</p>
            </Flex>
          </Link>
        </div>
        <div className={styles.announcmentBlock}>
          <Flex vertical gap={8}>
            <p className={styles.announcmentTitle}>Invite friend</p>
            <p className={styles.announcmentDescription}>Get</p>
          </Flex>
        </div>
      </div>
    </div>
  )
}
